import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { AlertCalendlyFreePlan } from 'entities/Integrations'
import { MessageField } from 'widgets/MessageField'
import { useChatbotContext, useChatbotDialogContext } from 'pages/chatbot/context'
import {
  CompletedAlert,
  MessageBoxWrapper,
  SaveAndRestartAlert,
} from 'pages/chatbot/ui/ChatbotDialog/MessageBoxWrapper'
import { AgentTestButton, AgentTestFollowupButton } from 'pages/chatbot/ui/ChatbotButtons'
import styles from '../styles.module.scss'

export const AgentMessageBox = observer(() => {
  const {
    id,
    agentBookAppointmentStepsStore: {
      isExistChanges,
      stepLoading,
      saveAgentBeforeTest,
      settingAgentStore,
    },
  } = useChatbotContext()
  const dialog = useChatbotDialogContext()
  const { isAutoConvType } = settingAgentStore

  const isDisabled = isExistChanges || stepLoading
  const isCompletedAlertDisabled = id === null || stepLoading || dialog.loading
  const isSaveAndRestartAlertDisabled =
    id === null || stepLoading || dialog.completed || dialog.loading

  const handleAlertAction = async () => {
    if (isExistChanges) {
      const isSaved = await saveAgentBeforeTest({ id: Number(id) })
      if (isSaved) dialog.restart(isAutoConvType)
    } else {
      dialog.restart(isAutoConvType)
    }
  }

  return (
    <MessageBoxWrapper dialog={dialog} disabled={isDisabled}>
      <CompletedAlert
        handleAction={handleAlertAction}
        disabled={isCompletedAlertDisabled}
        dialog={dialog}
      />
      <SaveAndRestartAlert
        handleAction={handleAlertAction}
        disabled={isSaveAndRestartAlertDisabled}
        dialog={dialog}
        isExistChanges={isExistChanges}
      />
      <AlertCalendlyFreePlan />
      {!isExistChanges && (
        <Box display='flex' gap={1} marginBottom={'5px'}>
          <div className={styles.dialogTestButton}>
            <AgentTestButton size='small' />
          </div>
          <div className={styles.dialogHeaderTestButton}>
            <AgentTestFollowupButton />
          </div>
        </Box>
      )}
      <MessageField messageFieldStore={dialog.message} />
    </MessageBoxWrapper>
  )
})
